/*
 * En el totem, al minuto sin que nadie lo toque, vuelta a la portada y arriba
 * del todo, como hacia el kiosko de antes.
 *
 * Una pantalla publica que se queda donde la dejo el ultimo visitante —en la
 * ficha de una experiencia, a media pagina— no invita al siguiente: tiene
 * pinta de estar ocupada o rota. La sesion de la web caduca a los treinta
 * minutos, pero eso solo cierra la sesion por dentro: no cambia de pantalla.
 *
 * Cuenta como actividad tocar, arrastrar, desplazar y teclear.
 */
import router from '@/router'

const SEGUNDOS = 60

export default function inactividadTotem() {
  let reloj = null

  const volver = () => {
    if (router.currentRoute.value.name !== 'Home') {
      router.push({ name: 'Home' })
    }
    window.scrollTo(0, 0)
  }

  const reiniciar = () => {
    clearTimeout(reloj)
    reloj = setTimeout(volver, SEGUNDOS * 1000)
  }

  for (const evento of ['pointerdown', 'pointermove', 'touchstart', 'keydown', 'wheel', 'scroll']) {
    window.addEventListener(evento, reiniciar, { passive: true, capture: true })
  }

  reiniciar()
}
